import * as action_types from '../actions/actionTypes'

const initialState = {
  isOpen: false
}

export default function toggleNotAuthorized(state = initialState, { type }) {
  switch (type) {
  case action_types.OPEN_NOT_AUTHORIZED:
    return { isOpen: true }
  case action_types.CLOSE_NOT_AUTHORIZED:
    return state
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notAuthorized.js